import React from "react";
import { NavLink } from "react-router-dom";
import i18n from "../../i18n";
import { getLoggedUser } from "../../state/user";
import { generateMzadcomID } from "../../state/utils";
import { SaudiRiyalLogo } from "../logo/saudiLogo";

const user = getLoggedUser();
let is_logged = localStorage.getItem("is_logged_in") ? true : false;
const allowed_roles = ["CE", "GM"];

function logout() {
  localStorage.clear();
  window.location.href = "/";
}

export class SideBarMob extends React.Component {
  constructor() {
    super();
    this.state = {
      dashboard_menu_expand: true,
      report_menu_expand: true,
    };
  }

  componentDidMount() { }

  componentDidUpdate(prevProps) {
    document.body.style = "";
  }

  render() {
    let { count } = this.state;
    let lang = localStorage.getItem("I18N_LANGUAGE");
    return (
      <React.Fragment>
        {is_logged && (
          <div>
            {/* User Profile Section */}
            <div className="show_mobile">
              <div>
                <div className="profile-card">
                  <div className="profile-main">
                    <div className="avatar-container d-flex" >
                      {user.avatar ? (
                        <img
                          src={user.avatar}
                          alt="user"
                          className="avatar-img"
                          referrerPolicy="no-referrer"
                        />
                      ) : (
                        <div className="avatar-placeholder">
                          <i className="icon icon-user"></i>
                        </div>
                      )}
                       {user.role === "U" && (
                      <>
                        <div style={{ paddingLeft: "20px" }}>

                          <div >{user.name}</div>
                          <div style={{ fontSize: "12px"}}>{user.email}</div>

                        </div>


                      </>
                    )}
                    </div>

                   


                    {user.role !== "U" && (<div className="menu-trigger-container">
                      <button
                        className="menu-trigger-btn"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasExample"
                        aria-controls="offcanvasExample"
                      >
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                      </button>
                    </div>)}

                  </div>



                  <div className="profile-divider"></div>

                  <div className="profile-info">
                    {user.role !== "U" && (
                      <>
                        <div className="info-row">
                          <span className="info-label">{i18n.t("name")} :</span>
                          <span className="info-value">{user.name}</span>
                        </div>

                        <div className="info-row">
                          <span className="info-label">{i18n.t("email")} :</span>
                          <span className="info-value">{user.email}</span>
                        </div>
                      </>
                    )}
                    <div className="info-row">
                      <span className="info-label">{i18n.t("mobile")} :</span>
                      <span className="info-value">{user.mobile}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">{i18n.t("mzadcom_id")} :</span>
                      <span className="info-value">{generateMzadcomID(user.id, user.role)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* User Role Menu */}
            {user.role === "U" && (
              <div className="show_mobile mobile-sidebar-offcanvas">
                <div className="wallet-container d-mob-none">
                  <div className="wallet-badge">
                    <img src="/assets/images/wallet-icon.png" alt="wallet" width="18" />
                    <span>
                      {i18n.t("wallet")}: {this.props.wallet_amount} <SaudiRiyalLogo />
                    </span>
                  </div>
                </div>

                <nav className="menu-list">
                  {["CE", "GM"].includes(user.role) && (
                    <NavLink activeClassName="active" to="/management" className="menu-link">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub1.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("management_dashboard")}</span>
                    </NavLink>
                  )}

                  {!["U", "CE", "GM"].includes(user.role) && (
                    <>
                      <NavLink activeClassName="active" to="/dashboard" className="menu-link">
                        <img
                          src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub1.png"}
                          alt=""
                          height="18"
                          width="18"
                        />
                        <span>{i18n.t("live_dashboard")}</span>
                      </NavLink>
                      <NavLink activeClassName="active" to="/dashboard-auc-eval" className="menu-link">
                        <img
                          src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub2.png"}
                          alt=""
                          height="18"
                          width="18"
                        />
                        <span>{i18n.t("auction_evaluation")}</span>
                      </NavLink>
                      <NavLink activeClassName="active" to="/dashboard-user-analysis" className="menu-link">
                        <img
                          src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub3.png"}
                          alt=""
                          height="18"
                          width="18"
                        />
                        <span>{i18n.t("user_analysis")}</span>
                      </NavLink>
                      <NavLink activeClassName="active" to="/dashboard-sales-eval" className="menu-link">
                        <img
                          src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub4.png"}
                          alt=""
                          height="18"
                          width="18"
                        />
                        <span>{i18n.t("sales_evaluation")}</span>
                      </NavLink>
                    </>
                  )}

                  <div className="row">
                    <NavLink activeClassName="active" to="/dashboard" className="menu-link">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub1.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("dashboard")}</span>
                    </NavLink>

                    <NavLink activeClassName="active" to="/profile" className="menu-link col-6">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/edit-profile-left-menu-icon.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("edit_profile")}</span>
                    </NavLink>

                    <NavLink activeClassName="active" to="/my_auctions" className="menu-link col-6">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/solar_key-outline.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("my_bids")}</span>
                    </NavLink>

                    <NavLink to="/wallet" className="menu-link" activeClassName="active">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/bi_cash-stack.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("my_wallet")}</span>
                    </NavLink>


                    <NavLink to="/winning_bids" className="menu-link" activeClassName="active">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/uil_trophy.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("winning_bids")}</span>
                    </NavLink>

                    <NavLink to="/site_visit" className="menu-link" activeClassName="active">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/heroicons-outline_search.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("site_visit")}</span>
                    </NavLink>

                    <NavLink activeClassName="active" to="/enrolled_auctions" className="menu-link col-6">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/ri_auction-line.png"}
                        alt=""
                        height="18"
                        width="18"
                      />
                      <span>{i18n.t("enrolled_auctions")}</span>
                    </NavLink>


                  </div>
                </nav>
              </div>
            )}

            {/* Non-User Role Dashboard */}
            {user.role !== "U" && (
              <div className="show_mobile">
                <div
                  className="offcanvas offcanvas-start sidebar-offcanvas"
                  tabIndex="-1"
                  id="offcanvasExample"
                  aria-labelledby="offcanvasExampleLabel"
                >
                  <div className="offcanvas-header sidebar-header">
                    <div className="header-content">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/dashboard-icon-black.png"}
                        alt="Dashboard"
                        height="20"
                      />
                      <span>{i18n.t("dashboard")}</span>
                    </div>
                    <button
                      type="button"
                      className="close-btn"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    >
                      ×
                    </button>
                  </div>

                  <div className="offcanvas-body sidebar-body">
                    <nav className="row">
                      {["U", "CE", "GM"].includes(user.role) && (
                        <NavLink activeClassName="active" to="/dashboard" className="menu-link col-6">
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/dashboard-sub1.png"}
                            alt=""
                            height="18"
                            width="18"
                          />
                          <span>{i18n.t("dashboard")}</span>
                        </NavLink>
                      )}

                      {!["U", "CE", "GM"].includes(user.role) && (
                        <>
                          <div className="menu-section">
                            <img
                              src={process.env.PUBLIC_URL + "/assets/images/dashboard-left-menu-icon.png"}
                              alt=""
                              height="18"
                              width="18"
                            />
                            <span>{i18n.t("dashboard")}</span>
                          </div>
                          <NavLink activeClassName="active" to="/dashboard" className="menu-link sub">
                            <span>{i18n.t("live_dashboard")}</span>
                          </NavLink>
                          <NavLink activeClassName="active" to="/dashboard-auc-eval" className="menu-link sub">
                            <span>{i18n.t("auction_evaluation")}</span>
                          </NavLink>
                          <NavLink activeClassName="active" to="/dashboard-user-analysis" className="menu-link sub">
                            <span>{i18n.t("user_analysis")}</span>
                          </NavLink>
                          <NavLink activeClassName="active" to="/dashboard-sales-eval" className="menu-link sub">
                            <span>{i18n.t("sales_evaluation")}</span>
                          </NavLink>
                        </>
                      )}

                      <NavLink activeClassName="active" to="/profile" className="menu-link">
                        <i className="icon icon-user"></i>
                        <span>{i18n.t("edit_profile")}</span>
                      </NavLink>

                      {(user.role === "A" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE" || user.role === "M") && (
                        <>
                          <NavLink to="/live_activity" activeClassName="active" className="menu-link" target="_blank">
                            <i className="fa fa-desktop"></i>
                            <span>{i18n.t("live_activity")}</span>
                          </NavLink>

                          <NavLink to="/users" activeClassName="active" className="menu-link">
                            <i className="fa fa-users"></i>
                            <span>{i18n.t("users")}</span>
                          </NavLink>

                          <NavLink to="/clients" activeClassName="active" className="menu-link">
                            <i className="mdi mdi-account-multiple"></i>
                            <span>{i18n.t("clients")}</span>
                          </NavLink>
                        </>
                      )}

                      {(user.role === "A" || user.role === "C" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE" || user.role === "F" || user.role === "M") && (
                        <NavLink activeClassName="active" to="/enrolled_users" className="menu-link">
                          <i className="fa fa-user-plus"></i>
                          <span>{i18n.t("enrolled_users")}</span>
                        </NavLink>
                      )}

                      {(user.role === "A" || user.role === "F") && (
                        <>
                          <NavLink to="/users-wallet" activeClassName="active" className="menu-link">
                            <i className="fa fa-money"></i>
                            <span>{i18n.t("mzadcom")} - {i18n.t("wallet")}</span>
                          </NavLink>
                          <NavLink to="/withdraw-requests" activeClassName="active" className="menu-link">
                            <i className="fa fa-undo"></i>
                            <span>{i18n.t("withdraw_requests")}</span>
                          </NavLink>
                        </>
                      )}

                      {user.role === "A" && (
                        <>
                          <NavLink to="/groups" activeClassName="active" className="menu-link">
                            <i className="fa fa-object-group"></i>
                            <span>{i18n.t("groups")}</span>
                          </NavLink>
                          <NavLink to="/masks" activeClassName="active" className="menu-link">
                            <i className="icon icon-layers"></i>
                            <span>{i18n.t("masks")}</span>
                          </NavLink>
                          <NavLink to="/categories" activeClassName="active" className="menu-link">
                            <i className="fa fa-list-alt"></i>
                            <span>{i18n.t("categories")}</span>
                          </NavLink>
                          <NavLink to="/organizations" activeClassName="active" className="menu-link">
                            <i className="fa fa-building"></i>
                            <span>{i18n.t("organizations")}</span>
                          </NavLink>
                          <NavLink to="/banners" activeClassName="active" className="menu-link">
                            <i className="fa fa-image"></i>
                            <span>{i18n.t("banners")}</span>
                          </NavLink>
                          <NavLink to="/blacklist" activeClassName="active" className="menu-link">
                            <i className="fa fa-ban"></i>
                            <span>{i18n.t("blacklist")}</span>
                          </NavLink>
                          <NavLink to="/create_auction" activeClassName="active" className="menu-link">
                            <i className="icon icon-plus"></i>
                            <span>{i18n.t("create_auction")}</span>
                          </NavLink>
                        </>
                      )}

                      {(user.role === "A" || user.role === "C" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE" || user.role === "M") && (
                        <NavLink to="/auctions_list" activeClassName="active" className="menu-link">
                          <i className="icon icon-diamond"></i>
                          <span>{i18n.t("my_auctions")}</span>
                        </NavLink>
                      )}

                      {(user.role === "A" || user.role === "PM" || user.role === "OM" || user.role === "F") && (
                        <NavLink to="/auction_approval" activeClassName="active" className="menu-link">
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/image 25.png"}
                            alt=""
                            width="18"
                            height="18"
                          />
                          <span>{user.role === "F" ? i18n.t("supplier_payment") : i18n.t("auction_approval")}</span>
                        </NavLink>
                      )}

                      {user.role === "A" && (
                        <NavLink to="/approved_auctions" activeClassName="active" className="menu-link">
                          <i className="fa fa-check"></i>
                          <span>{i18n.t("approved_auctions")}</span>
                        </NavLink>
                      )}

                      {user.role === "U" && (
                        <>
                          <NavLink activeClassName="active" to="/my_auctions" className="menu-link">
                            <i className="icon icon-folder-alt"></i>
                            <span>{i18n.t("my_bids")}</span>
                          </NavLink>
                          <NavLink activeClassName="active" to="/enrolled_auctions" className="menu-link">
                            <i className="icon icon-folder-alt"></i>
                            <span>{i18n.t("enrolled_auctions")}</span>
                          </NavLink>
                          <NavLink activeClassName="active" to="/winning_bids" className="menu-link">
                            <i className="icon icon-folder-alt"></i>
                            <span>{i18n.t("winning_bids")}</span>
                          </NavLink>
                        </>
                      )}

                      <NavLink activeClassName="active" to="/site_visit" className="menu-link">
                        <i className="icon icon-credit-card"></i>
                        <span>{i18n.t("site_visit")}</span>
                      </NavLink>

                      {(user.role === "A" || user.role === "M" || user.role === "C") && (
                        <NavLink activeClassName="active" to="/payments" className="menu-link">
                          <i className="icon icon-credit-card"></i>
                          <span>{i18n.t("payment")}</span>
                        </NavLink>
                      )}

                      {(user.role === "A" || user.role === "PM" || user.role === "OM") && (
                        <NavLink activeClassName="active" to="/client-payments" className="menu-link">
                          <i className="mdi mdi-bank"></i>
                          <span>{i18n.t("client_payment")}</span>
                        </NavLink>
                      )}

                      {(user.role === "A" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE") && (
                        <NavLink activeClassName="active" to="/refund" className="menu-link">
                          <i className="fa fa-money"></i>
                          <span>
                            {i18n.t("refund")}
                            {allowed_roles.includes(user.role) && count && (
                              <span className="badge">{count}</span>
                            )}
                          </span>
                        </NavLink>
                      )}

                      <NavLink activeClassName="active" to="/auction_tracker" className="menu-link">
                        <i className="mdi mdi-history"></i>
                        <span>{i18n.t("track_auctions")}</span>
                      </NavLink>

                      <NavLink activeClassName="active" to="/auction_liked" className="menu-link">
                        <i className="icon icon-like"></i>
                        <span>{i18n.t("liked_auctions")}</span>
                      </NavLink>

                      <NavLink activeClassName="active" to="/auction_wishlisted" className="menu-link">
                        <i className="icon icon-heart"></i>
                        <span>{i18n.t("wishlisted_auctions")}</span>
                      </NavLink>

                      {(user.role === "A" || user.role === "C" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE" || user.role === "F" || user.role === "M") && (
                        <div className="menu-group">
                          <button
                            className="menu-toggle"
                            onClick={() => {
                              this.setState({
                                report_menu_expand: !this.state.report_menu_expand,
                              });
                            }}
                          >
                            <i className="fa fa-file-text-o"></i>
                            <span>{i18n.t("reports")}</span>
                            <i className={`fa fa-chevron-${this.state.report_menu_expand ? 'up' : 'down'} arrow`}></i>
                          </button>

                          {this.state.report_menu_expand && (
                            <div className="submenu">
                              <NavLink activeClassName="active" to="/auction_bid_report" className="menu-link sub">
                                <span>{i18n.t("auction_bid_report")}</span>
                              </NavLink>
                              <NavLink activeClassName="active" to="/winners" className="menu-link sub">
                                <span>{i18n.t("auction_winners")}</span>
                              </NavLink>
                              {(user.role === "A" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE" || user.role === "M") && (
                                <>
                                  <NavLink to="/sales_report" activeClassName="active" className="menu-link sub">
                                    <span>{i18n.t("sales_report")}</span>
                                  </NavLink>
                                  <NavLink to="/final_report" activeClassName="active" className="menu-link sub">
                                    <span>{i18n.t("final_report")}</span>
                                  </NavLink>
                                  <NavLink to="/position_report" activeClassName="active" className="menu-link sub">
                                    <span>{i18n.t("position_report")}</span>
                                  </NavLink>
                                  <NavLink to="/wallet_summary" activeClassName="active" className="menu-link sub">
                                    <span>{i18n.t("wallet_summary")}</span>
                                  </NavLink>
                                </>
                              )}
                              <NavLink to="/reports" activeClassName="active" className="menu-link sub">
                                <span>{i18n.t("reports")}</span>
                              </NavLink>
                            </div>
                          )}
                        </div>
                      )}

                      {(user.role === "A" || user.role === "PM" || user.role === "OM" || user.role === "GM" || user.role === "CE" || user.role === "M") && (
                        <NavLink to="/composer" activeClassName="active" className="menu-link">
                          <i className="fa fa-bell-o"></i>
                          <span>{i18n.t("composer")}</span>
                        </NavLink>
                      )}

                      <button onClick={logout} className="menu-link logout">
                        <i className="icon icon-power"></i>
                        <span>{i18n.t("logout")}</span>
                      </button>
                    </nav>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <style jsx>{`
          /* Profile Card */
          .profile-card {
            background: white;
            border-radius: 12px;
            padding: 15px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
          }

          .profile-main {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .avatar-container {
            flex-shrink: 0;
          }

          .avatar-img {
            width: 50px;
            height: 50px;
            border-radius: 10px;
            object-fit: cover;
          }

          .avatar-placeholder {
            width: 50px;
            height: 50px;
            border-radius: 10px;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #189397;
            font-size: 20px;
          }

          .profile-text {
            flex: 1;
            min-width: 0;
          }

          .profile-name {
            font-size: 16px;
            font-weight: 600;
            color: #1a1a1a;
            margin-bottom: 2px;
          }

          .profile-email {
            font-size: 13px;
            color: #666;
          }

          .profile-divider {
            height: 1px;
            background: #f0f0f0;
            margin: 16px 0;
          }

          .profile-info {
            display: flex;
            flex-direction: column;
            gap: 2px;
          }

          .info-row {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
          }

          .info-label {
            color: #888;
          }

          .info-value {
            color: #333;
            font-weight: 500;
          }

          /* Wallet Container */
          .wallet-container {
            padding: 0 16px 12px;
          }

          .wallet-badge {
            background: #189397;
            color: white;
            padding: 12px 16px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 14px;
            font-weight: 500;
          }

          /* Menu List */
          .menu-list {
            padding: 0 16px 16px;
          }

         .menu-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px;
  border-radius: 8px;
  color: #333;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 14px;
  background: transparent;
  border: none;
  text-align: center;
  cursor: pointer;
  margin: 0 8px;
  width: auto;
  flex: 1;
  // max-width: 200px;
  justify-content: center;
}

.menu-link:hover {
  background: #f8f8f8;
  color: #189397;
}

.menu-link.active {
  background: #189397;
  color: white;
}

.menu-link img,
.menu-link i {
  flex-shrink: 0;
  width: 18px;
  text-align: center;
}

.menu-link span {
  white-space: nowrap;
}

.menu-list {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

          /* Menu Section */
          .menu-section {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 14px;
            margin-top: 8px;
            margin-bottom: 4px;
            font-weight: 600;
            font-size: 13px;
            color: #666;
          }

          /* Menu Group */
          .menu-group {
            margin-bottom: 4px;
          }

          .menu-toggle {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 14px;
            border-radius: 8px;
            color: #333;
            background: transparent;
            border: none;
            width: 100%;
            text-align: left;
            cursor: pointer;
            font-size: 14px;
            transition: all 0.2s;
          }

          .menu-toggle:hover {
            background: #f8f8f8;
          }

          .menu-toggle i {
            width: 18px;
            text-align: center;
          }

          .menu-toggle span {
            flex: 1;
          }

          .menu-toggle .arrow {
            font-size: 11px;
            color: #999;
          }

          .submenu {
            padding-top: 4px;
          }

          /* Badge */
          .badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            background: #bdc532;
            color: #333;
            border-radius: 10px;
            font-size: 11px;
            font-weight: 600;
            margin-left: 8px;
          }

          /* Menu Trigger */
          .menu-trigger-container {
            padding: 16px;
          }

          .menu-trigger-btn {
            background: white;
            border: 1px solid #e0e0e0;
            border-radius: 10px;
            padding: 12px 14px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            gap: 4px;
            transition: all 0.2s;
          }

          .menu-trigger-btn:hover {
            border-color: #189397;
          }

          .bar {
            width: 24px;
            height: 2px;
            background: #333;
            border-radius: 2px;
            transition: all 0.2s;
          }

          .menu-trigger-btn:hover .bar {
            background: #189397;
          }

          /* Offcanvas */
          .sidebar-offcanvas {
            border: none;
            box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);
            max-width: 300px;
          }

          .sidebar-header {
            background: white;
            border-bottom: 1px solid #f0f0f0;
            }`}</style>
      </React.Fragment>
    );
  }
}